/*
 *
 * This enum corresponds to the `npssource` table in the source database
 * and is used to identify various product sources for which NPS scores are collected.
 *
 * Each value represents a specific product, with the numeric value serving
 * as its unique identifier in the database.
 *
 * Note: The values are not sequential. Refer to the database for the most up-to-date mappings.
 *
 */

export enum NpsEnum {
  APP = 1,
  ONE_CLICK_DEAL_ADM = 2,
  CONTRACT_MANAGEMENT = 3,
  MARKET_INTELLIGENCE_BRAZIL = 4,
  MARKET_INTELLIGENCE_PARAGUAY = 5,
  EASY_BARTER_ADM = 6,
  ONE_CLICK_DEAL_LDC = 7,
  ONE_CLICK_DEAL_CARGILL = 8,
  ONE_CLICK_DEAL_AMAGGI = 9,
  EASY_BARTER_BASF = 10,
  EASY_BARTER_BAYER = 11,
  GDVIP = 12,
  CF_PRODUCTOR = 13,
  EASY_BARTER_CIMOAGRO = 14,
  EASY_BARTER_PETROVINA = 15,
  EASY_BARTER_SLC = 16,
  EASY_BARTER_CONECTA = 17,
  EASY_BARTER_AMAGGI = 18,
  CLIENT_MANAGEMENT_ADM = 19,
  MARKET_INTELLIGENCE_CORPORATE = 20,
  TRANSCTIONAL_SITE = 21,
  EASY_BARTER_RIO_BRANCO = 22,
  KEY_ACCOUNTS_CORPORATE = 23,
  LOGISTICS_PLANNING_ADM = 24,
  EASY_BARTER_SOAGRO = 25,
  EASY_BARTER_HINOVE = 26,
  EASY_BARTER_UBYFOL = 27,
  EASY_BARTER_ADUBOS_PARANAIBA = 28,
  AIRTON_CONVERSATIONAL = 29,
  CHAT_BIONIC_COMMERCIAL = 30,
  EASY_BARTER_BALDAN = 31,
  EASY_BARTER_DECIO = 32,
  EASY_BARTER_JUMIL = 33,
  EASY_BARTER_ICL = 34,
}
